import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const navLinks = [
  { label: '首页', path: '/' },
  { label: '网红塌房', path: '/' },
  { label: '选秀黑幕', path: '/' },
  { label: '综艺翻车', path: '/' },
  { label: '直播爆料', path: '/' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location]);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-6 md:px-10">
        <div className="flex items-center justify-between h-16 md:h-18">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-2 flex-shrink-0">
            <div className="w-9 h-9 rounded-lg bg-primary-500 flex items-center justify-center">
              <i className="ri-fire-fill text-background-50 text-lg"></i>
            </div>
            <div className="hidden sm:block">
              <span className="text-foreground-900 font-bold text-base whitespace-nowrap font-heading">
                每日大赛黑料
              </span>
              <span className="text-foreground-500 text-xs block leading-tight whitespace-nowrap">
                一手爆料 · 吃瓜不停
              </span>
            </div>
          </Link>

          {/* Desktop Nav */}
          <div className="hidden md:flex items-center gap-1">
            {navLinks.map((link) => {
              const isActive = location.pathname === link.path;
              return (
                <Link
                  key={link.path}
                  to={link.path}
                  className={`px-3 py-2 rounded-lg text-sm font-medium transition-colors duration-200 whitespace-nowrap ${
                    isActive
                      ? 'text-primary-600 bg-primary-50'
                      : scrolled
                        ? 'text-foreground-700 hover:text-foreground-900 hover:bg-background-100'
                        : 'text-background-50/90 hover:text-background-50 hover:bg-white/10'
                  }`}
                >
                  {link.label}
                </Link>
              );
            })}
          </div>

          {/* Desktop CTA */}
          <div className="hidden md:flex items-center gap-3">
            <Link
              to="/about"
              className={`text-sm font-medium transition-colors duration-200 whitespace-nowrap ${
                scrolled ? 'text-foreground-600 hover:text-foreground-900' : 'text-background-50/80 hover:text-background-50'
              }`}
            >
              关于我们
            </Link>
            <a
              href="#subscribe"
              className="px-5 py-2 bg-primary-500 text-background-50 text-sm font-semibold rounded-full whitespace-nowrap hover:bg-primary-600 transition-colors cursor-pointer"
            >
              订阅爆料
            </a>
          </div>

          {/* Mobile Toggle */}
          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className="md:hidden w-10 h-10 flex items-center justify-center rounded-lg"
            aria-label="菜单"
          >
            <i
              className={`text-xl ${
                scrolled ? 'text-foreground-900' : 'text-background-50'
              } ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}
            ></i>
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70">
          <div className="px-6 py-4 flex flex-col gap-1">
            {navLinks.map((link) => {
              const isActive = location.pathname === link.path;
              return (
                <Link
                  key={link.path}
                  to={link.path}
                  className={`px-4 py-3 rounded-lg text-sm font-medium transition-colors duration-200 ${
                    isActive
                      ? 'text-primary-600 bg-primary-50'
                      : 'text-foreground-700 hover:text-foreground-900 hover:bg-background-100'
                  }`}
                >
                  {link.label}
                </Link>
              );
            })}
            <Link
              to="/about"
              className="px-4 py-3 rounded-lg text-sm font-medium text-foreground-600 hover:text-foreground-900 hover:bg-background-100 transition-colors duration-200"
            >
              关于我们
            </Link>
            <a
              href="#subscribe"
              className="mt-2 px-5 py-3 bg-primary-500 text-background-50 text-sm font-semibold rounded-full text-center whitespace-nowrap hover:bg-primary-600 transition-colors cursor-pointer"
            >
              订阅爆料
            </a>
          </div>
        </div>
      )}
    </nav>
  );
}